import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { v4 as uuidv4 } from 'uuid'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import i18n from 'i18next'
import * as R from 'ramda'

import SurveyPage from './SurveyPage'
import Menu from '../UniformComponents/Menu'
import Switch from '../UniformComponents/Switch'
import Input from './form/Input'

@observer
class PageBlock extends Component {
    constructor(props) {
        super(props)
        const { pageBlock } = this.props
        this.state = { title: pageBlock.title }
        this.menuOptions = this.getMenu()
    }

    previewPageBlock = () => {
        const { store, pageBlock } = this.props
        const { survey } = store
        const pages = survey.pages.filter((p) => pageBlock.pages.includes(p.id))
        const firstPage = pages.find((p) => !p.isHidden)
        if (!firstPage) {
            return
        }
        let link = store.survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)
        link += `&pageId=${firstPage.id}`
        store.gotoExternal(link)
    }

    getBlockTitle = () => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata
        const { title } = this.state
        return R.hasPath([surveyLocale], title)
            ? title[surveyLocale].text
            : R.pathOr('', [defaultLocale, 'text'], title)
    }

    updateTitle = () => {
        const { store, pageBlock } = this.props
        const { survey } = store
        survey.pageBlocks.forEach((pb) => {
            if (pb.id === pageBlock.id) {
                pb.title = this.state.title
            }
        })
        survey.updatePageBlocks(store, survey.pageBlocks)
    }

    onTitleChange = (e) => {
        const { store } = this.props
        const { surveyLocale } = store
        this.setState({ title: { ...this.state.title, [surveyLocale]: { text: e.target.value } } })
    }

    toggleHidePageBlock = () => {
        const { store, pageBlock } = this.props
        const { survey } = store

        if (!pageBlock.isHidden) {
            store.pageBlockToEdit = pageBlock
            store.pageBlockHideConfirm = true

            return
        }

        survey.pageBlocks.forEach((pb) => {
            if (pb.id === pageBlock.id) {
                pb.isHidden = !pageBlock.isHidden
            }
        })
        survey.updatePageBlocks(store, survey.pageBlocks)
    }

    deletePageBlock = () => {
        const { store, pageBlock } = this.props
        const { survey } = store
        const tryDelete = survey.deletePageBlock(store, pageBlock.id)

        if (!tryDelete) {
            store.pageBlockToEdit = pageBlock
            store.pageBlockDeleteConfirm = true
        }
    }

    getPageIndex = (pageId) => {
        const { store } = this.props
        const { survey } = store
        return survey.pages
            .map(({ id }) => id)
            .indexOf(pageId)
    }

    getMenu = () => (
        [
            {
                id: uuidv4(),
                compName: 'preview',
                icon: 'fa-light fa-eye',
                label: i18n.t('s_alt_previewpageblock'),
                onClick: this.previewPageBlock,
            },
            {
                id: uuidv4(),
                compName: 'delete',
                label: i18n.t('s_alt_delpageblock'),
                icon: 'fal fa-times-circle deleteicon',
                greyBg: true,
                onClick: this.deletePageBlock,
            },
        ].map(({
            onClick, label, icon, id,
        }) => (
            <div className="question-item" key={id}>
                <div className="option-line" onClick={onClick}>
                    <i className={icon} />
                    <p dangerouslySetInnerHTML={{ __html: i18n.t(label) }} />
                </div>
            </div>
        ))
    )

    // TODO: TH create PageBlock functions and style
    render() {
        const { index, pageDragId } = this.props
        const { store, pageBlock } = this.props
        const { survey } = store
        const { standardPages } = survey
        const pages = standardPages.filter((sp) => pageBlock.pages.includes(sp.id))

        return (
            <div className="panel survey-builder-pageblock-container" style={{ minHeight: '170px', backgroundColor: '#E8FCFA' }}>
                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>
                            {i18n.t('PageBlock_PageBlock')}
                            :
                            {' '}
                            {index + 1}
                        </span>
                        <Input
                            type="text"
                            disabled={store.survey.closed || pageBlock.isHidden}
                            value={this.getBlockTitle()}
                            onBlur={this.updateTitle}
                            onChange={this.onTitleChange}
                        />
                    </div>
                    <div className="options-container">
                        <span className="question-accordion-switch-container">
                            <Switch
                                state={!pageBlock.isHidden}
                                externalState
                                onToggle={this.toggleHidePageBlock}
                            />
                        </span>
                        <Menu
                            cssClass="option-menu"
                            list={this.menuOptions}
                            minWidth={300}
                            dir="left"
                            hasUniqueLast
                        >
                            <div className="menu-icon">
                                <i className="fa-regular fa-ellipsis-vertical" />
                            </div>
                        </Menu>
                    </div>
                </div>
                <div style={pageBlock.isHidden ? { pointerEvents: 'none' } : null}>
                    <Droppable droppableId={`pageblock_${pageBlock.id}`} type="pageList" isDropDisabled={pageBlock.isHidden}>
                        {(provided, snapshot) => (
                            <div
                                style={{
                                    border: '0px solid red',
                                    minHeight: '150px',
                                    padding: '5px',
                                    opacity: pageBlock.isHidden ? 0.4 : 1,
                                }}
                                ref={provided.innerRef}
                            >
                                {pages.map((page, index) => (
                                    <Draggable
                                        key={`draggable_${index}`}
                                        draggableId={`surveyPage_${page.id}`}
                                        isDragDisabled={survey.closed}
                                        id={`draggable_${index}`}
                                        index={index}
                                    >
                                        {(provided, snapshot) => (
                                            <div>
                                                <SurveyPage
                                                    provided={provided}
                                                    key={page.id}
                                                    store={store}
                                                    page_id={this.getPageIndex(page.id)}
                                                    page={page}
                                                    history={history}
                                                    pageDragId={pageDragId}
                                                    draggableId={`surveyPage_${page.id}`}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>
            </div>
        )
    }
}

export default PageBlock
